import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Target, Shield, Zap, Clock, Lock, Rocket } from 'lucide-react';
import './WhyChoose.css';

const WhyChoose = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const reasons = [
    { icon: <Target size={32} />, text: 'Industry-Focused AI' },
    { icon: <Shield size={32} />, text: 'Scalable & Secure Architecture' },
    { icon: <Zap size={32} />, text: 'Rapid Deployment' },
    { icon: <Clock size={32} />, text: '24x7 AI Operations' },
    { icon: <Lock size={32} />, text: 'Enterprise-Grade Reliability' },
    { icon: <Rocket size={32} />, text: 'Future-Ready Technology' },
  ];

  return (
    <section className="whychoose-section" ref={ref} data-testid="whychoose-section">
      <div className="container">
        <motion.div
          className="whychoose-header"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <h2 className="section-title-white" data-testid="whychoose-title">
            Why Choose DanstonAI
          </h2>
          <p className="section-subtitle-white" data-testid="whychoose-subtitle">
            Built for Performance. Designed for Growth.
          </p>
        </motion.div>

        <div className="reasons-grid">
          {reasons.map((reason, index) => (
            <motion.div
              key={index}
              className="reason-card glass-card"
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ delay: index * 0.08, duration: 0.4, ease: 'easeOut' }}
              data-testid={`reason-${index}`}
            >
              <div className="reason-icon">{reason.icon}</div>
              <p className="reason-text">{reason.text}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="whychoose-tagline"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ delay: 0.8, duration: 0.8 }}
          data-testid="whychoose-tagline"
        >
          <p>Your business doesn't stop. Neither does our AI.</p>
        </motion.div>
      </div>
    </section>
  );
};

export default WhyChoose;
